var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.thisTab
    }
  }, [_c('v-layout', {
    staticClass: "h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('div', [_c('pages-head'), _c('v-divider')], 1), _c('div', {
    staticStyle: {
      "flex": "1",
      "overflow": "hidden"
    }
  }, [_c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "no-gutters": ""
    }
  }, [!_vm.mobile ? _c('v-col', {
    staticClass: "fill-height tabs-pages__side",
    attrs: {
      "cols": "12",
      "xl": ""
    }
  }, [_c('pages-side', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1) : _vm._e(), !_vm.mobile ? _c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1) : _vm._e(), _c('v-col', {
    key: _vm.key,
    staticClass: "fill-height tabs-pages__body",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "cols": "12",
      "xl": ""
    }
  }, [_vm.isOn ? _c('pages-body', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e(), _vm.mobile ? _c('pages-tool', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e(), _vm.mobile ? _c('pages-edit') : _vm._e(), _vm.mobile ? _c('pages-list', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e()], 1), !_vm.mobile ? _c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1) : _vm._e(), !_vm.mobile ? _c('v-col', {
    staticClass: "fill-height tabs-pages__desc",
    attrs: {
      "cols": "12",
      "xl": ""
    }
  }, [_c('pages-desc', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1) : _vm._e()], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "v-btn-group flex-wrap my-12"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('prev');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    attrs: {
      "color": "grey-6"
    }
  }, [_vm._v("mdi-chevron-left")]), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 이전 단계 ")])], 1), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('save');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v("저장하기")])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }